import type { ReferenceField } from '@uncinc/react-drupal-core/types';

import type { ProfileDefault, ProfileExternal } from '../../../types/uncinc_profile/profile';

export function profileTeamWidgetMapper(profiles: ReferenceField<ProfileDefault>[]) {
  return profiles.map((profile) => profile.entity).filter((profile) => profile !== undefined);
}

export function profileExternalTeamWidgetMapper(profiles: ReferenceField<ProfileExternal>[]) {
  return profiles.map((profile) => profile.entity).filter((profile) => profile !== undefined);
}
